import React from 'react';
import { FieldArray } from '@framework/ui/Organisms/FinalForm';
import SpeakersTable from './SpeakersTable';
import { useCallFormContext } from '../CallFormContext';

import styles from './speakersTable.module.scss';

interface IProps {
  disabled: boolean,
}

const SpeakersTableFieldArray = ({ disabled }: IProps) => {
  const { isEvercall } = useCallFormContext();

  return (
    <>
      <div className={ isEvercall ? styles.landingTableTitle : styles.headerTable }>
        { isEvercall ? 'Speakers information needed' : 'Speakers' }
      </div>
      <FieldArray
        name="speakers"
        disabled={ disabled }
        component={ SpeakersTable }
      />
    </>
  );
};

export default SpeakersTableFieldArray;
